import { useEffect, useState } from "react";
import { Container, Panel, Form, SelectPicker, Grid, Col, Row } from "rsuite";
import { updateIn } from "json-immut";
import { useTranslation } from "react-i18next";
import { HelperServices } from "../../../core/services/HelperServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { useSelector } from "react-redux";

import {
  messageTypeArr,
  httpStatusArr,
} from "../../../core/config/AppConstants";
import "./AreasImport.css";

function AreaImport() {
  const [importedRows, setImportedRows] = useState<any[]>([]);
  const [failedRows, setFailedRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const countryList = useSelector((state: any) => state.country.data);
  const [countryData, setCountryData] = useState<any[]>([]);
  const [stateData, setStateData] = useState<any[]>([]);
  const [cityData, setCityData] = useState<any[]>([]);
  const [defaultCountry, setDefaultCountry] = useState({ id: "", name: "" });
  const [rows, setRows] = useState(10);
  const [page, setPage] = useState(1);
  const [sort_by, setSortBy] = useState();
  const [sort_order, setSortOrder] = useState();
  const { t } = useTranslation();
  const [errors, setErrors] = useState<any>({});
  const downloadFileUrl = "/Import_Formats/Areas_import.xlsx";
  const areaImportFormIntialVal = {
    id: "",
    city: [],
    state: [],
    country: [],
  };
  const [areaImportFormData, setAreaImportFormData] = useState<any>(
    areaImportFormIntialVal
  );

  async function getCountries() {
    try {
      setLoading(true);
      if (countryList) {
        let countriesArr = [];
        for (let i of countryList) {
          countriesArr.push({ label: i.country_name, value: i.id });
        }
        setCountryData(countriesArr);
        for (let i of countriesArr) {
          if (i.label == "India") {
            setDefaultCountry({ id: i.value, name: i.label });
            break;
          }
        }
      } else {
        setCountryData([]);
        setStateData([]);
        setCityData([]);
      }
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      console.log("error ", error);
    }
  }

  async function getStates(params: any) {
    try {
      const response: any = await HelperServices.getAllValidStates(params);
      if (response && response.status === httpStatusArr.ok) {
        let statesArr = [];
        for (let obj of response.data.data) {
          statesArr.push({ label: obj.state_name, value: obj.id });
        }
        setStateData(statesArr);
      } else {
        setStateData([]);
        setCityData([]);
      }
    } catch (error: any) {
      console.log("error ", error);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
    }
  }

  async function getCities(param: any) {
    try {
      setLoading(true);
      const response: any = await HelperServices.getCities(param);
      if (response && response.status === httpStatusArr.ok) {
        let citysArr = [];
        for (let obj of response.data.data) {
          citysArr.push({ label: obj.city_name, value: obj.id });
        }
        setCityData(citysArr);
      } else {
        setCityData([]);
      }
      setLoading(false);
    } catch (error: any) {
      console.log("error ", error);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setLoading(false);
    }
  }

  async function init() {
    try {
      await getCountries();
    } catch (error: any) {
      console.log("error ", error);
    }
  }
  useEffect(() => {
    init();
  }, [countryList]);

  const handleAreaFormChange = (data: any) => {
    if (data.path == "status") {
      if (data.value) {
        data.value = 1;
      } else {
        data.value = 0;
      }
    } else if (
      data.path == "country" &&
      data.value != null &&
      data.value != ""
    ) {
      getStates({ country: data.value });
    } else if (data.path == "state" && data.value != null && data.value != "") {
      getCities({
        state: data.value,
        page: 1,
        rows: rows,
        sort_by: sort_by,
        sort_order: sort_order,
        is_allowed: "0,1",
      });
    }
    let form = updateIn(areaImportFormData, [data.path], data.value);
    setAreaImportFormData(form);
  };

  const handleImport = ($event: { target: { files: any } }) => {
    const files = $event.target.files;
    const file = files[0];
    const reader = new FileReader();
    let data = {
      file: files[0],
    };
    uploadXLSX(data);
    reader.readAsArrayBuffer(file);
  };

  async function uploadXLSX(params: any) {
    let formData = { ...areaImportFormData };
    try {
      var data = new FormData();
      data.append("file", params.file);
      data.append("city_id", String(formData.city));
      const response: any = await HelperServices.importArea(data);
      if (response && response.status === httpStatusArr.ok) {
        setImportedRows(response.data.data.imported);
        setFailedRows(response.data.data.failed);
      } else {
        UtilityServices.showToaster({
          message: response?.data?.message,
        });
      }
    } catch (error: any) {
      console.log("error ", error);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
    }
  }

  return (
    <>
      <div className="users cntry">
        <Container className="container">
          <Panel>
            <Grid fluid>
              <Row className="show-grid">
                <Col md={12}>
                  <h4 className="mb-3">{t("IMPORT") + " " + t("AREA")}</h4>
                </Col>
              </Row>
              <div className="row">
                <div className="col-md-12 form-flex">
                  <Form formValue={areaImportFormData}>
                    <Form.Group controlId="country" className="mb-0">
                      <Form.Control
                        name="country"
                        accepter={SelectPicker}
                        appearance="default"
                        placeholder={t("SELECT_COUNTRY")}
                        data={countryData}
                        className={
                          errors["country"]
                            ? "form-select is-invalid"
                            : "form-select"
                        }
                        onChange={(v: any) =>
                          handleAreaFormChange({ path: "country", value: v })
                        }
                      />
                      <span className="text-danger">{errors["country"]}</span>
                    </Form.Group>
                    <Form.Group controlId="state" className="mb-0">
                      <Form.Control
                        name="state"
                        accepter={SelectPicker}
                        appearance="default"
                        placeholder={t("SELECT_STATE")}
                        data={stateData}
                        className={
                          errors["state"]
                            ? "form-select  is-invalid"
                            : "form-select"
                        }
                        onChange={(v: any) => {
                          handleAreaFormChange({ path: "state", value: v });
                        }}
                      />
                      <span className="text-danger">{errors["state"]}</span>
                    </Form.Group>
                    <Form.Group controlId="city" className="mb-0">
                      <Form.Control
                        name="city"
                        accepter={SelectPicker}
                        appearance="default"
                        placeholder="Select City"
                        data={cityData}
                        className={
                          errors["city"]
                            ? "form-select is-invalid"
                            : "form-select"
                        }
                        onChange={(v: any) =>
                          handleAreaFormChange({ path: "city", value: v })
                        }
                      />
                    </Form.Group>
                  </Form>
                  <div className="input-group">
                    <div className="custom-file">
                      <input
                        type="file"
                        name="file"
                        className="custom-file-input"
                        id="inputGroupFile"
                        required
                        onChange={handleImport}
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      />
                    </div>
                    <div>
                      <a
                        href={downloadFileUrl}
                        download="Areas_Import_Format.xlsx"
                        className="button"
                      >
                        {t("DOWNLOAD") + " " + t("FORMAT")}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col-md-12">
                  <h4 className="mb-3">{t("IMPORTED_RECORDS")}</h4>
                  <table className="table importedrowstab mb-3">
                    <thead>
                      <tr>
                        <th scope="col">{t("S_NO")}</th>
                        <th scope="col">{t("CODE")}</th>
                        <th scope="col">{t("NAME")}</th>
                        <th scope="col">{t("TYPE")}</th>
                        <th scope="col">{t("PINCODE")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {importedRows.length ? (
                        importedRows.map((importedrow, index) => (
                          <tr className="importeddatarow" key={index}>
                            <th scope="row">{index + 1}</th>
                            <td>{importedrow.area_code}</td>
                            <td>{importedrow.area_name}</td>
                            <td>{importedrow.area_type}</td>
                            <td>
                              <span className="badge bg-warning text-dark">
                                {importedrow.pincode}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr className="importeddatarow">
                          <td className="text-center" colSpan={5}>
                            {t("NO_RECORD_IMPORTED")}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <hr />
                <div className="col-md-12">
                  <h4 className="mb-3">{t("FAILED_RECORDS")}</h4>
                  <table className="table importedrowstab">
                    <thead>
                      <tr>
                        <th scope="col">{t("S_NO")}</th>
                        <th scope="col">{t("DESCRIPTION")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {failedRows.length ? (
                        failedRows.map((failedRows, index) => (
                          <tr className="failedddatarow" key={index}>
                            <th scope="row">{index + 1}</th>
                            <td>{failedRows}</td>
                          </tr>
                        ))
                      ) : (
                        <tr className="failedddatarow">
                          <td className="text-center" colSpan={5}>
                            {t("NO_RECORD_FOUND")}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </Grid>
          </Panel>
        </Container>
      </div>
    </>
  );
}

export default AreaImport;
